import actions from "./actions";

const {FETCH_ATTENDANCE, FETCH_ATTENDANCE_RESET, FETCH_ATTENDANCE_REPORTS, FETCH_ATTENDANCE_REPORTS_RESET} = actions;
const initState = {
    attendance: [],
    attendanceReports: [],
};

const AttendanceReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_ATTENDANCE:
            return {
                ...state,
                attendance: data
            }
        case FETCH_ATTENDANCE_RESET:
            return {
                ...state,
                attendance: initState.attendance,
            };
        case FETCH_ATTENDANCE_REPORTS:
            return {
                ...state,
                attendanceReports: data
            }
        case FETCH_ATTENDANCE_REPORTS_RESET:
            return {
                ...state,
                attendanceReports: initState.attendanceReports,
            };
        default:
            return state;
    }
}

export default AttendanceReducer;
